import React from "react"
import {
  makeStyles, Avatar, Typography, Link, Tooltip, IconButton, List, ListItem,
  ListItemText, Divider, Card, CardMedia, CardContent, Grid, Button
} from "@material-ui/core"
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import NftIcon from "./NftIcon";
import { logger } from '../config/pino';
import { string } from "prop-types";
import { useSnackbar } from "notistack"
import Chip from '@material-ui/core/Chip';
import InfoIcon from '@material-ui/icons/Info';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudIcon from '@material-ui/icons/Cloud';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import BuildIcon from '@material-ui/icons/Build';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Skeleton } from "@material-ui/lab";


// One liners to generate templated URLs
const nftContractUrl = (address: string) => `https://etherscan.io/token/${address}`
const nftTokenUrl = (address: string, token: string) => `https://etherscan.io/token/${address}?a=${token}`
const erc1155TokenUrl = (address: string, token: string) => `https://opensea.io/assets/${address}/${token}`
const nftOwnerUrl = (address: string) => `https://etherscan.io/address/${address}`
const ensOwnerUrl = (address: string) => `https://etherscan.io/address/${address}`


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  card: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
  },
  cardContent: {
    // display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardText: {
    // display: 'flex',
    textAlign: 'center',
  },
  avatar: {
    margin: 0,
    backgroundColor: '#000000',
    color: '#f6c26c',
    alignSelf: 'center'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  media: {
    maxWidth: `500px`,
    // width: `50%`
    //maxHeight: '350px',
    // height: '25vw',
    objectFit: "contain"
  },
  submit: {
    margin: theme.spacing(3, 0, 1),
    backgroundColor: '#000000',
  },
  // used for padding around loading bar/spinner
  loading: {
    // marginTop: theme.spacing(3),
    // marginBottom: theme.spacing(3),
    height: '5rem',
    width: '100%',
  },
  loadingText: {
    display: 'inline-block',
    width: '3rem',
  },
  cardRow: {
    display: 'flex',
    'flex-direction': 'row',
  },
  validatorHeader: {
    textAlign: 'center',
    margin: 'auto',
    'margin-left': '2%',
  },
  validatorDescription: {
    fontSize: '0.8125rem',
    'margin': 'auto',
    'margin-top': '0.5rem',
    'margin-bottom': '0.6rem',
  },
  validatorDescriptionBottom: {
    fontSize: '0.7rem',
    margin: 'auto',
    textAign: 'center',
    display: 'block',
    color: 'rgba(0, 0, 0, 0.87) !important',
    // backgroundColor: 'blue'
  },
  chipList: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.2),
    'padding-left': 0,
    'padding-right': 0,
    margin: 0,
    // '& > *': {
    //   margin: theme.spacing(0.2),
    // },
  },
  chipItem: {
    // margin: theme.spacing(0.2),
    fontSize: '0.8125rem',
    color: 'rgba(0, 0, 0, 0.7)'
  },
  chipIcon: {
    // margin: theme.spacing(0.2),
    fontSize: '0.625rem',
    color: 'rgba(0, 0, 0, 0.7)'
  },
  infoTooltip: {
    fontSize: '1rem !important',
    padding: '0',
    margin: 0
  },
  infoListRow: {
    display: 'flex',
    'flex-direction': 'row',
    width: '100%'
  },
  infoList: {
    padding: '1.5rem 0.5rem',
  },
  infoListItem: {
    //padding: 0,
    'padding-left': '2%',
    margin: 0,
  },
  bottomTooltip: {
    height: '1rem',
    width: '1rem',
    fontSize: '1rem !important',
    display: 'block',
    margin: 'auto',
    padding: 0,
  },
  bottomButtonIcons: {
    fontSize: '1.3rem !important',
    padding: '0',
    color: 'rgba(0, 0, 0, 0.54) !important'
  },
  bottomLink: {
    color: 'inherit',
    textDecoration: 'none !important'
  },
  bottomButtons: {
    // height: '5rem',
    width: '5rem',
    display: 'table-cell',
    textAlign: 'center',
    verticalAlign: 'middle',
    wordWrap: 'normal',
    textTransform: 'none',
    borderRadius: '10px',
    border: 0,
    color: theme.palette.text.primary,
    lineHeight: '0',
  }
}));

export function NftCard({
  nameOwner = "",
  nftOwner = "",
  nftAddress = "",
  nftTokenId = "",
  nftOwnersENS = "",
  isLoading = true,
  isError = false,
  errorMsg = "",
  metadata = {
    attributes: [{ trait_type: '', value: '' }],
    title: string,
    description: string,
    external_url: string,
    image: string,
    name: string,
    address: string,
    token_id: string,
    EIPXXX: {
      public_key: "",
      validator_index: "",
      document: "",
      withdrawal_key: "",
    }
  }
}) {

  // 'Copied!' Tooltips
  const [nftContractTooltipOpen, setNftContractTooltipOpen] = React.useState(false);
  const [nftTokenTooltipOpen, setNftTokenTooltipOpen] = React.useState(false);
  const [nftOwnerTooltipOpen, setNftOwnerTooltipOpen] = React.useState(false);
  const [nameOwnerTooltipOpen, setNameOwnerTooltipOpen] = React.useState(false);

  // 'Copied!' Tooltips show/hide functions
  const handleNftCopyClose = () => {
    setNftContractTooltipOpen(false);
  };
  const handleNftCopy = () => {
    navigator.clipboard.writeText(nftAddress)
    setNftContractTooltipOpen(true);
    setTimeout(() => setNftContractTooltipOpen(false), 500)
  };
  const handleTokenCopyClose = () => {
    setNftTokenTooltipOpen(false);
  };
  const handleTokenCopy = () => {
    navigator.clipboard.writeText(nftTokenId)
    setNftTokenTooltipOpen(true);
    setTimeout(() => setNftTokenTooltipOpen(false), 500)
  };
  const handleTokenOwnerCopyClose = () => {
    setNftOwnerTooltipOpen(false);
  };
  const handleTokenOwnerCopy = () => {
    navigator.clipboard.writeText(nftOwner)
    setNftOwnerTooltipOpen(true);
    setTimeout(() => setNftOwnerTooltipOpen(false), 500)
  };
  const handleNameOwnerCopyClose = () => {
    setNameOwnerTooltipOpen(false);
  };
  const handleNameOwnerCopy = () => {
    navigator.clipboard.writeText(nameOwner)
    setNameOwnerTooltipOpen(true);
    setTimeout(() => setNameOwnerTooltipOpen(false), 500)
  };

  // Queue error messages to the snackbar
  const { enqueueSnackbar } = useSnackbar();
  if (errorMsg.length > 0) {
    console.log(`NFT Card error: ${errorMsg}`)
    enqueueSnackbar(errorMsg, {
      variant: 'error',
      autoHideDuration: 3000,
    });
  }

  // Parse data from the metadata object
  let validatorPublicKey: string = '1'
  let validatorPublicKeySnippet: string = ''
  let balance: string = '...'
  let status: string = '...'
  let client: string = 'Unknown'
  let operator: string = 'Unknown'
  let custodian: string = 'Unknown'
  let nav: string = '...'
  let document: string = '#'

  // Shorten public key
  if (!!metadata.EIPXXX && !!metadata.EIPXXX.public_key) {
    validatorPublicKey = metadata.EIPXXX.public_key
    validatorPublicKeySnippet = `${metadata.EIPXXX.public_key.substr(0, 6)}...${metadata.EIPXXX.public_key.substr(metadata.EIPXXX.public_key.length - 6, 6)}`
  }
  else {
    validatorPublicKeySnippet = "..."
  }

  // Retrieve document URL
  if (!!metadata.EIPXXX && !!metadata.EIPXXX.document) {
    document = metadata.EIPXXX.document
  }

  // Parse attributes array
  if (!!metadata.attributes) {
    console.log(`Searching for a balance attribute to parse`)
    console.log(metadata.attributes)
    const validatorBalance = metadata.attributes.find((attributeObject) => {
      if (!!attributeObject.trait_type && attributeObject.trait_type === "Balance") {
        return true
      } else {
        return false
      }
    })
    // Confirm find didn't return undefined
    if (!!validatorBalance) {
      console.log(`Valdiator balance: ${validatorBalance.value}`)
      // For now calculate the net asset value for a validator as -0.1
      const bal = Number(validatorBalance.value)
      nav = (bal - 0.1).toFixed(5) + ' ♦'
      balance = bal.toFixed(5) + ' ♦'
    }

    // Parse client
    const clientAttribute = metadata.attributes.find((attributeObject) => (!!attributeObject.trait_type && attributeObject.trait_type === "Client"))
    if (!!clientAttribute) {
      console.log(`Client returned: ${clientAttribute.value}`)
      client = clientAttribute.value
    }

    // Parse status
    const statusAttribute = metadata.attributes.find((attributeObject) => (!!attributeObject.trait_type && attributeObject.trait_type === "Status"))
    if (!!statusAttribute) {
      console.log(`Status returned: ${statusAttribute.value}`)
      status = statusAttribute.value
    }
  }



  // logger.debug(`Rendering Nft Card.`)
  logger.info(`Metadata object supplied to NftCard.tsx: ${JSON.stringify(metadata)}`)

  const classes = useStyles();
  return (
    <Card variant="outlined" className={classes.card}>

      {isLoading ? <Skeleton variant="rect" className={classes.loading} /> :
        <CardMedia
          className={classes.media}
          component="img"
          image={!!metadata.image ? metadata.image.toString() : '/SocialPreviewKS.png'}
          title="NFT Image"
        />
      }

     
        <CardContent className={classes.cardContent}>

          <div className={classes.cardRow}>
            <Avatar className={classes.avatar}>
              {!isError && (<NftIcon />)}
              {!!isError && (<ErrorOutlineIcon />)}
            </Avatar>

            <Typography component="h1" variant="h5" className={classes.validatorHeader} gutterBottom>
              <span style={{ fontWeight: 'bold' }}>Validator: </span>
              {
                !isLoading && !!metadata.EIPXXX && !!metadata.EIPXXX.validator_index ? `#${metadata.EIPXXX.validator_index}` : <Skeleton variant="text" className={classes.loadingText}/>
              }
            </Typography>
          </div>

          <div className={classes.cardRow}>
            <Typography component="p" className={classes.validatorDescription} gutterBottom>
              {
                !isLoading && !!metadata.description ? metadata.description : <Skeleton variant="text" className={classes.loadingText}/>
              }
            </Typography>
          </div>

          {/* NOTES on Chip
              - can only use primary, secondary or default color
              - can't apply styling to the label (i.e. for emboldening the client/status/operator text)
              - likely gonna need a custom module
              - once we know what to do with this section and have data for it, it can be cleaned into loop
          */}
          <div className={classes.cardRow}>
            <ul className={classes.chipList}>
              <li>
                <Chip
                  label={ 
                      isLoading ? <span><b>Client: </b><Skeleton variant="text" className={classes.loadingText}/></span>: <span><b>Client:</b> {client}</span>
                    }
                  className={classes.chipItem}
                  icon={<BuildIcon className={classes.chipIcon} />}
                  size="small"
                  variant="default"
                  color="secondary"
                />
              </li>
              <li>
                <Chip
                  label={
                    isLoading ? <span><b>Status: </b><Skeleton variant="text" className={classes.loadingText}/></span>: <span><b>Status:</b> {status}</span>
                  }
                  className={classes.chipItem}
                  icon={<PlayCircleFilledIcon />}
                  size="small"
                  variant="default"
                  color="secondary"
                />
              </li>
              <li>
                <Chip
                  label={
                    isLoading ? <span><b>Operator: </b><Skeleton variant="text" className={classes.loadingText}/></span>: <span><b>Operator:</b> {operator}</span>
                  }
                  className={classes.chipItem}
                  icon={<CloudIcon />}
                  size="small"
                  variant="default"
                  color="secondary"
                />
              </li>
              <li>
                <Chip
                  label={
                    isLoading ? <span><b>Custodian: </b><Skeleton variant="text" className={classes.loadingText}/></span>: <span><b>Custodian:</b> {custodian}</span>
                  }
                  className={classes.chipItem}
                  icon={<VpnKeyIcon />}
                  size="small"
                  variant="default"
                  color="secondary"
                />
              </li>
            </ul>
          </div>

          {/* Balance, NAV, Public Key 
              - again, can be cleaned into loop once datas flowing in
          */}
          <List className={classes.infoList}>
            <ListItem className={classes.infoListItem}>
              <div className={classes.infoListRow}>
                <ListItemText>
                  <span style={{ fontSize: '0.8125rem', fontWeight: 'bold' }}>
                    Current Validator Balance: <span style={{ fontWeight: 'normal' }}>{
                      isLoading ? <Skeleton variant="text" className={classes.loadingText}/> : balance
                    }</span>
                  </span>
                </ListItemText>
                <Tooltip title="Balance in Ether" className={classes.infoTooltip}>
                  <IconButton>
                    <InfoIcon className={classes.infoTooltip} />
                  </IconButton>
                </Tooltip>
              </div>
            </ListItem>
            <Divider />
            <ListItem className={classes.infoListItem}>
              <div className={classes.infoListRow}>
                <ListItemText>
                  <span style={{ fontSize: '0.8125rem', fontWeight: 'bold' }}>
                    Net Asset Value (NAV): <span style={{ fontWeight: 'normal' }}>
                    {
                      isLoading ? <Skeleton variant="text" className={classes.loadingText}/> : nav
                    }
                    </span>
                  </span>
                </ListItemText>
                <Tooltip title="Net Fees" className={classes.infoTooltip}>
                  <IconButton>
                    <InfoIcon className={classes.infoTooltip} />
                  </IconButton>
                </Tooltip>
              </div>
            </ListItem>
            <Divider />
            <ListItem className={classes.infoListItem}>
              <div className={classes.infoListRow}>
                <ListItemText>
                  <span style={{ fontSize: '0.8125rem', fontWeight: 'bold' }}>
                    Validator Public Key: <span style={{ fontWeight: 'normal' }}>
                    {
                      isLoading ? <Skeleton variant="text" className={classes.loadingText}/> : validatorPublicKeySnippet
                    }
                    </span>
                  </span>
                </ListItemText>
                <Tooltip title="ID of Validator" className={classes.infoTooltip}>
                  <IconButton>
                    <InfoIcon className={classes.infoTooltip} />
                  </IconButton>
                </Tooltip>
              </div>
            </ListItem>
          </List>

          {/* Bottom of page links
              - not sure on what size we want the icons
              - might want to draw circles around them too like in jira
              - again, can be cleaned into loop once datas flowing in
          */}
          <div className={classes.cardRow}>
            <Grid container spacing={2} justify="center" >
              <Grid item>
                <Link
                  href={`https://beaconcha.in/validator/${validatorPublicKey}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  component="a"
                  className={classes.bottomLink}
                >
                  <Button className={classes.bottomButtons}>
                    <ExitToAppIcon className={classes.bottomButtonIcons} />
                    <Typography component="p" className={classes.validatorDescriptionBottom} >
                      View on Beaconcha.in
                    </Typography>
                  </Button>
                </Link>

              </Grid>
              <Grid item>
                <Link
                  href={`${document}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  component="a"
                  className={classes.bottomLink}
                >
                  <Button className={classes.bottomButtons}>
                    <GetAppIcon className={classes.bottomButtonIcons} />
                    <Typography component="p" className={classes.validatorDescriptionBottom} >
                      Legal Agreement
                    </Typography>
                  </Button>
                </Link>
              </Grid>
              <Grid item>
                <Link
                  href={`https://opensea.io/assets/${nftAddress}/${nftTokenId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  component="a"
                  className={classes.bottomLink}
                >
                  <Button className={classes.bottomButtons}>
                    <ShoppingCartIcon className={classes.bottomButtonIcons} />
                    <Typography component="p" className={classes.validatorDescriptionBottom} >
                      Bid on OpenSea
                    </Typography>
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </div>

        </CardContent>
      
    </Card>
  )
}
